// Tipos que llegan del backend (mantén mayúsculas tal cual)
export type SapAliado = {
    IdAliados: string
    Aliado: string
}

// Opción para el Select
export type AllyOption = {
    label: string
    value: string // se conserva con ceros a la izquierda
}

// Utilidad para mapear respuesta → opciones del Select
export const mapSapAliadosToOptions = (data: SapAliado[] = []): AllyOption[] =>
    data.map((a) => ({ label: a.Aliado, value: a.IdAliados }))
